import React from 'react'
import api, { METHODS } from './api'
import { WidgetGallery, Attachment, AttachmentResponse } from '../common/types/api/page'
import { Recipient } from '../common/types/form'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export async function getWidgetPreview(
    widgetConfig: WidgetGallery,
    recipient: Recipient = {
        enabled: true,
        name: '',
        recipients: [],
        lookups: {}
    }
): Promise<Array<Attachment>> {
    try {
        return (
            await api<AttachmentResponse>(
                `preview/widget`,
                METHODS.POST,
                JSON.stringify({
                    widgetConfig,
                    recipient
                })
            )
        ).attachments as Array<Attachment>
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error getting widget preview: ')}>{error}</Notification>,
            20
        )

        console.error(error)

        return null
    }
}
